// This is just an example,
// so you can safely delete all default props below

export default {
    back: 'Tilbake',
    title: 'Tittel',
    user: 'Bruker',
    save: 'Lagre',
}
